export enum DataConciliatorActionTypes {
  INVALIDATE_USER_SETS = 'data-conciliator/INVALIDATE_USER_SETS',
}
